import defaultSettings from '../defaultSettings';

//sentry-webpack 配置，上传sourceMap使用
export default {
  include: './dist',
  release: `${defaultSettings.projectName}` + '2.0.0', //版本号，每次发版之前要修改版本号
  urlPrefix: '~', //访问域名的js根目录 如 url/static/ 则需要配置~/static
};
